import { render } from "./Tgmenber.vue?vue&type=template&id=35f0d8f7&scoped=true"
import script from "./Tgmenber.vue?vue&type=script&lang=js"
export * from "./Tgmenber.vue?vue&type=script&lang=js"

import "./Tgmenber.vue?vue&type=style&index=0&id=35f0d8f7&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f0d8f7"]])

export default __exports__